<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户还款记录'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :multipleSelectionOperation="listMultipleSelectionOperation"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import PayPledgeFinancingComponent from '../../components/PayFinancingComponent'
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'FinanceRepaymentList',
    data() {
      return {
        transactionStatus: this.$route.query['fi.transactionStatus'],
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '流水号',
            field: 'cj__reference'
          },
          {
            name: '还款方式',
            field: 'cj__channel',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '交易时间',
            field: 'cj__postingDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            name: '客户姓名',
            field: 'i__contactPerson'
          },
          // {
          //   name: '支付方式',
          //   field: ''
          // },
          {
            name: '金额(元)',
            field: 'cj__postingAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '还款账户',
            field: 'cj__outboundAccountDesc',
          },
          {
            name: '收款账户',
            field: 'cj__inboundAccountDesc',
          },
          {
            name: '备注',
            field: 'cj__remarks',
          },
          {
            name: '状态',
            formatter: function (r,c,v) {
              return '还款完成'
            }
          },
          {
            name: '操作',
            opts:[
              {
                clickHandler: (index, row)=>{
                  this.$router.push({path: 'Detail?cj.reference='+ row.cj__reference})
                },
                class: 'el-icon-info',
                name: '查看'
              },
            ]
          }
        ],
        listMultipleSelectionOperation: [
        ],
        payTransactionId: '',
        dialogVisible: false,
        payAccountList: [],
        loanAccountList: [],
        filters: {
          form: {
            fi__transactionNo: '',
            u__customerName: '',
            ct__debtorName: '',
            fi__transactionDate: [],
            ct__productName: ''
          },
          columns: [
            {
              label: '交易时间',
              component: 'date-range-picker',
              field: 'cj__postingDate'
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'u__customerName'
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerCashJournalRepayList()
          }
        }
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.cj.referenceType': 'REPAY',
            'xlist.search.cj.referenceType.op': 'eq',
            'xlist.sort.dataField': 'cj.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerCashJournalRepayList()
      }
    },
    mounted() {
      this.getCustomerCashJournalRepayList()
    },
    components: {
      DataTable,
      PayPledgeFinancingComponent
    },
    methods: {
      getCustomerCashJournalRepayList: function () {
        xhr.getCustomerCashJournalList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinanceRepaymentList.vue